import React, { useState } from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import styles from "./ResetPassword.module.css";
import { Email, Lock } from "../../Svg";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import { toast } from 'react-toastify';
import api from '../../utils/api';
import { useNavigate, useParams } from 'react-router-dom';

const ResetPassword = () => {
    const [passwordVisible, setPasswordVisible] = useState(false);
    const [cpasswordVisible, setcPasswordVisible] = useState(false);
    const [isResetDone, setIsResetDone] = useState(false);
    const token = useParams()?.id; 
    const navigate = useNavigate();
    
    const togglePasswordVisibility = () => {
        setPasswordVisible(!passwordVisible);
    };

    const formik = useFormik({
        initialValues: {
            newPassword: '',
            confirmPassword: '',
        },
        validationSchema: Yup.object({
            newPassword: Yup.string()
                .min(6, 'Password must be at least 6 characters')
                .required('New password is required'),
            confirmPassword: Yup.string()
                .oneOf([Yup.ref('newPassword'), null], 'Passwords must match')
                .required('Confirm password is required')
        }),
        onSubmit: async (values) => {
            try {
                const data = {
                    password: values.newPassword,
                    confirmPassword: values.confirmPassword,
                    token
                };
                const response = await api.resetPassword(data);
                if (response.data) {
                    toast.success(response.data?.data?.message || 'Password reset successfully');
                    setIsResetDone(true);
                }
            } catch (err) {
                console.log('Reset Password Error', err);
                toast.error(err?.response?.data?.message || 'something went wrong')
            } 
        }
    });

    return (
        <div className={styles.logincontainer}>
            <div className={styles.loginimageSection}>
                <div className={styles.imageOverlayText}>
                    <h2>ELECTROWIZ</h2>
                    <p>The Complete Enterprise Platform for Electronic Component Distribution & Supply Chain Management.</p>
                </div>
            </div>
            <div className={styles.loginformSection}>
                <div className={styles.blob1}></div>
                <div className={styles.blob2}></div>
                <div className={styles.loginFormCard}>
                    {isResetDone ? (
                        <div className={styles.successContainer}>
                            <div className={styles.successIconContainer}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                                    <polyline points="20 6 9 17 4 12"></polyline>
                                </svg>
                            </div>
                            <div className={styles.loginwelcomeText}>
                                <div className={styles.loginlogo}>
                                    <span className={styles.logoIcon}>⚡</span>
                                    <span className={styles.logoText}>ELECTROWIZ</span>
                                </div>
                                <h1>Password Reset Successful!</h1>
                                <p>Your password has been successfully updated. You can now return to the login screen and log in with your new password.</p>
                            </div>
                            <button onClick={() => navigate('/')} className={styles.loginButton}>
                                Back to Login
                            </button>
                        </div>
                    ) : (
                        <>
                            <div className={styles.loginwelcomeText}>
                                <div className={styles.loginlogo}>
                                    <span className={styles.logoIcon}>⚡</span>
                                    <span className={styles.logoText}>ELECTROWIZ</span>
                                </div>
                                <h1>Reset Password!</h1>
                            </div>
                            <form className={styles.loginformMain} onSubmit={formik.handleSubmit}>
                                <label>New password</label>
                                <div className={styles.logininputContainer}>
                                    <Lock />
                                    <input
                                        type={passwordVisible ? "text" : "password"}
                                        placeholder="********"
                                        className={styles.logininputField}
                                        {...formik.getFieldProps('newPassword')}
                                    />
                                    <FontAwesomeIcon
                                        icon={passwordVisible ? faEyeSlash : faEye}
                                        className={styles.loginpasswordIcon} onClick={togglePasswordVisibility}
                                    />
                                </div>
                                {formik.touched.newPassword && formik.errors.newPassword ? (
                                    <div className={styles.error}>{formik.errors.newPassword}</div>
                                ) : null}
                                
                                <label>Confirm new password</label>
                                <div className={styles.logininputContainer}>
                                    <Lock />
                                    <input
                                        type={cpasswordVisible ? "text" : "password"}
                                        placeholder="********"
                                        className={styles.logininputField}
                                        {...formik.getFieldProps('confirmPassword')}
                                    />
                                    <FontAwesomeIcon
                                        icon={cpasswordVisible ? faEyeSlash : faEye}
                                        className={styles.loginpasswordIcon} onClick={() => setcPasswordVisible(!cpasswordVisible)}
                                    />
                                </div>
                                {formik.touched.confirmPassword && formik.errors.confirmPassword ? (
                                    <div className={styles.error}>{formik.errors.confirmPassword}</div>
                                ) : null}
                                <button type="submit" className={styles.loginButton} disabled={formik.isSubmitting}>
                                    {formik.isSubmitting ? 'Please wait...' : 'Submit'}
                                </button>
                            </form>
                        </>
                    )}
                </div>
            </div>
        </div>
    );
};

export default ResetPassword;
